<template>
  <div class="day">
    <a-table
      :dataSource="dataSource"
      rowKey="id"
      :columns="columns"
      :scroll="{ x: 1300 }"
      :pagination="false"
    >
      <template #publishName="{ record }">
        <div class="flex-s-c">
          <img :src="record.headImageUrl" class="avatar" />
          <span class="margin-l10">{{ record.publishName }}</span>
        </div>
      </template>
      <!-- 操作列 -->
      <template #operate="operate">
        <div class="flex-c-c">
          <a-button
            type="primary"
            size="small"
            @click="showDetail(operate.record)"
            >详情</a-button
          >
          <template v-if="operate.record.scheduleStatus == 1">
            <a-button
              type="primary"
              size="small"
              @click="showModal(operate.record)"
              >编辑</a-button
            >
            <a-popconfirm
              title="确定取消该日程吗？"
              ok-text="是"
              cancel-text="否"
              @confirm="cancel(operate.record.id)"
            >
              <a-button type="primary" size="small">取消</a-button>
            </a-popconfirm>
            <a-popconfirm
              title="确定删除该日程吗？"
              ok-text="是"
              cancel-text="否"
              @confirm="del(operate.record)"
            >
              <a-button type="primary" danger size="small">删除</a-button>
            </a-popconfirm>
          </template>
        </div>
      </template>
    </a-table>
    <!-- 分页 -->
    <div class="yf-pagination pad-y40 flex-e-c" v-if="listobj.total">
      <a-pagination
        v-model:current="listobj.pageNum"
        v-model:pageSize="listobj.pageSize"
        :total="listobj.total"
        show-size-changer
        show-quick-jumper
        :show-total="(total) => `共 ${total} 条`"
        @change="pageChange"
        @showSizeChange="showSizeChange"
      />
    </div>
  </div>
</template>

<script>
import moment from "moment";
export default {
  inject: ["passTime", "callBack"],
  props: {
    listobj: {
      type: Object,
      default: () => ({
        list: [],
        total: 0,
        pageNum: 1,
        pageSize: 10,
      }),
    },
  },
  data() {
    return {
      current: 1,
      columns: [
        {
          title: "日程类型",
          dataIndex: "type",
          key: "type",
          fixed: "left",
          customRender: ({ text }) => {
            const type = {
              1: "训练日程",
              2: "普通日程",
            };
            return type[text];
          },
        },
        {
          title: "标题",
          dataIndex: "scheduleName",
          fixed: "left",
          key: "scheduleName",
        },
        {
          title: "时间",
          dataIndex: "createTime",
          key: "createTime",
          customRender: ({ record }) => {
            const start = record.startTime
              ? moment(record.startTime).format("yyyy-MM-DD HH:mm:ss")
              : "";
            const end = record.endTime
              ? moment(record.endTime).format("yyyy-MM-DD HH:mm:ss")
              : "";
            return `${start} 至 ${end}`;
          },
        },
        {
          title: "发布人",
          dataIndex: "publishName",
          key: "publishName",
          slots: {
            customRender: "publishName",
          },
        },
        {
          title: "发布时间",
          dataIndex: "createTime",
          key: "createTime",
          customRender: ({ text }) => {
            return text ? moment(text).format("yyyy-MM-DD HH:mm:ss") : "";
          },
        },
        {
          title: "状态",
          dataIndex: "scheduleStatus",
          key: "scheduleStatus",
          customRender: ({ text }) => {
            const scheduleStatus = {
              1: "未开始",
              2: "进行中",
              3: "已完成",
              4: "已取消",
            };
            return scheduleStatus[text];
          },
        },
        {
          title: "操作",
          dataIndex: "operate",
          key: "operate",
          align: "center",
          fixed: "right",
          width: 280,
          slots: {
            customRender: "operate",
          },
        },
      ],
    };
  },
  computed: {
    dataSource() {
      return this.listobj.list;
    },
  },
  methods: {
    showDetail(i) {
      if (i.type == 2) {
        this.$emit("toDetail", i.id);
      } else if (i.type == 1) {
        this.$router.push({
          path: "/plan/detail",
          query: {
            drillId: i.drillId,
            type: 3,
            time: +this.passTime()
          },
        });
      }
    },
    // 取消日程
    cancel(id) {
      this.$axios
        .post("/sys/schedule/updateByStatus", {
          id,
          status: 0,
        })
        .then((res) => {
          if (res.code == 200) {
            this.$message.success(res.msg);
            this.reflash();
          }
        });
    },
    showModal(i) {
      if (i.type == 2) {
        this.$emit("editForm", JSON.parse(JSON.stringify(i)));
      } else if (i.type == 1) {
        this.$router.push({
          path: "/plan/add",
          query: {
            drillId: i.drillId,
            type: 3,
            time: +this.passTime()
          },
        });
      }
    },
    showSizeChange(current, size) {
      this.$emit("pageSizeChange", size);
    },
    pageChange(page) {
      this.$emit("pageChange", page);
    },
    // 刷新数据
    reflash() {
      this.callBack(new Date(+this.passTime()));
    },
    // 删除
    del(record) {
      const params = {
        ids: [record.id],
      };
      this.$axios.post(`/sys/schedule/del`, params).then((res) => {
        if (res.code == 200) {
          this.$message.success("删除成功");
          // 当前页面删除完后就请求上一页面
          if (this.listobj.pageNum > 1 && this.dataSource.length == 1) {
            this.$emit("pageChange", this.listobj.pageNum - 1);
          } else {
            // 刷新数据
            this.reflash();
          }
        }
      });
    },
  },
  created() {},
};
</script>
<style lang='less' scoped>
.avatar {
  width: 32px;
  height: 32px;
  border-radius: 50%;
}
/deep/ .ant-table-thead > tr > th {
  white-space: nowrap;
}
</style>